module.exports = __webpack_public_path__ + "img/19.2db3478a.jpg";